import React, { useContext, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import authServices from '../services/AuthServices.js';
import apiClient from '../api/apiClient.js';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import { Link, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const Login = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ShowEye, setShowEye] = useState(false);

  const { login } = useContext(AuthContext);

  const [mobile, setMobile] = useState('');
  const [password, setpassword] = useState('');
  const [host, setHost] = useState(apiClient.defaults.baseURL);

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      if (host && isValidUrl(host)) {
        localStorage.setItem('host', host);
        apiClient.defaults.baseURL = host;
      }

      setIsSubmitting(true);
      const response = await authServices.login(mobile, password);

      if (response.token) {
        login(response.token.data);
        toast.success(response.token.message);
      } else {
        toast.error(response.errorMsg);
      }
    } catch (error) {
      toast.error(error.response ? error.response.errorMsg : error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-xxl-3 col-lg-4 col-md-5">
        <div className="auth-full-page-content d-flex p-sm-5 p-4">
          <div className="w-100">
            <div className="d-flex flex-column h-100">
              <div className="mb-4 mb-md-5 mt-4 text-center">
                <a href="index.html" className="d-block auth-logo">
                  <img src="assets/images/MMB_LOGO/MMB_LOGO.png" alt="" height={30} />{" "}
                  <span className="logo-txt">MMB</span>
                </a>
              </div>
              <div className="auth-content my-auto">
                <div className="text-center">
                  <h5 className="mb-0">Welcome Back !</h5>
                  <p className="text-muted mt-2">
                    Sign in to continue to MMB.
                  </p>
                </div>

                {/* Form starts here */}
                <form className="mt-4 pt-2" onSubmit={handleLogin}>

                  {/* Host field hidden
                  <div className="mb-3">
                    <label className="form-label">Host</label>
                    <input
                      type="text"
                      className="form-control"
                      id="host"
                      placeholder="Enter Host"
                      value={host}
                      onChange={(e) => setHost(e.target.value)}
                    />
                  </div>
                  */}

                  <div className="mb-3">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      maxLength={10}
                      id="username"
                      placeholder="Enter Number"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type={ShowEye ? 'text' : 'text'}
                      className="form-control"
                      id="password"
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setpassword(e.target.value)}
                    />
                    {/* Uncomment this to enable toggle view */}
                    {/* 
                    <button
                      className="btn btn-light shadow-none"
                      type="button"
                      id="password-addon"
                      onClick={() => setShowEye(!ShowEye)}
                    >
                      {ShowEye ? <FaRegEye /> : <FaRegEyeSlash />}
                    </button> 
                    */}
                  </div>

                  <div className="row mb-4">
                    <div className="col">
                      <Link to="/forget_pass">
                        <span>Forgot password ?</span>
                      </Link>
                    </div>
                  </div>

                  <div className="mb-3">
                    <button
                      className="btn btn-primary w-100 waves-effect waves-light"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Processing...' : 'Login'}
                    </button>
                  </div>
                </form>

                <div className="mt-5 text-center">
                  {/* <p className="text-muted mb-0">
                    Don't have an account ?{" "}
                    <a
                      href="auth-register.html"
                      className="text-primary fw-semibold"
                    >
                      {" "}
                      Signup now{" "}
                    </a>{" "}
                  </p> */}
                </div>
              </div>
              <div className="mt-4 mt-md-5 text-center">
                <p className="mb-0">
                  © Managed{" "}
                  <a href="https://webdekho.in">
                    <i className="mdi mdi-heart text-danger" /> by Webdekho.in
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* end auth full page content */}
      </div>
    </>
  );
};

export default Login;
